import { Button } from '../catalyst/button';
import { serializeCsv, type CsvColumn } from './csv';

export function ExportAsCSVButton({
  data,
  columns,
  title,
}: {
  data: Record<string, unknown>[];
  columns: CsvColumn[];
  title: string;
}) {
  return (
    <Button
      color="light"
      onClick={() => {
        const csv = serializeCsv(data, columns);
        downloadText(csv, `${title}.csv`, 'text/csv');
      }}
    >
      Export as CSV
    </Button>
  );
}

export function downloadText(text: string, filename: string, contentType: string) {
  const blob = new Blob([text], { type: contentType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  // Revoke the object URL after a short delay to ensure the download has started
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 10_000);
}
